import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/AboutUS.css'; 

gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Text animation - replays on each scroll
      gsap.fromTo(textRef.current,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );

      // Image animation - replays on each scroll
      gsap.fromTo(imageRef.current,
        { x: 50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="about-section" ref={sectionRef}>
      <div className="about-contnt">
        <div className="about-text" ref={textRef}>
      <h2 className='abt'>About Automotive Devices</h2>

          <p className="about-text-lf" style={{   fontSize:"19px" }}> 

   Automotive Devices delivers high-quality PCBA and electronics manufacturing services tailored to modern industry demands.<br></br>

With strong expertise in consumer and industrial electronics, we provide end-to-end solutions focused on precision, flexibility, and engineering excellence.<br></br>

Our capabilities include advanced SMT (Surface Mount Technology), efficient assembly processes, and state-of-the-art inspection systems to ensure consistent quality and performance.<br></br>

From rapid prototyping to high-volume production, we offer scalable and reliable manufacturing solutions designed to meet diverse technical requirements.<br></br>

We are committed to delivering accuracy, efficiency, and dependable results—helping our clients bring their products to market with confidence.<br></br>
          </p>
        </div>
        <div className="about-image" ref={imageRef}>
          <img
            src="/about.png" 
            alt="About Us"

          />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
